<template>
    <div>
        <p>Zdjęcia</p>
        <div class="filters">
            <el-button :type="showUnaccepted ? 'primary' : 'basic'"
                       @click="showUnaccepted = !showUnaccepted">
                Pokaż odrzucone
            </el-button>
            <el-button :type="showAccepted ? 'primary' : 'basic'"
                       @click="showAccepted = !showAccepted">
                Pokaż zaakceptowane
            </el-button>
        </div>
        <ul class="list" v-loading="previewIsUpdating">
            <li class="item"
                v-show="tileVisible(photo)"
                v-for="photo in instagramPhotos">
                <img :src="photo.thumbnail_src" alt="" class="thumbnail">
                <div class="photo__buttons">
                    <el-button size="small" title="Akceptuj"
                               @click="changePhotoStatus(photo, true)"
                               :type="photosDict[photo.id] && photosDict[photo.id].accepted ? 'primary' : 'basic'">
                        <i class="fa fa-check-circle"></i>
                    </el-button>
                    <el-button size="small"
                               @click="changePhotoStatus(photo, false)"
                               title="Odrzuć"
                               :type="photosDict[photo.id] && !photosDict[photo.id].accepted ? 'danger' : 'basic'">
                        <i class="fa fa-remove"></i>
                    </el-button>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
    import {InstagramFolder} from '@/api/'

    export default {
        props: ["form"],
        data () {
            return {
                previewIsUpdating: false,
                showUnaccepted: false,
                showAccepted: false,
                instagramPhotos: []
            }
        },
        computed: {
            photosDict () {
                // photos converted from list to object
                const photosDict = {}
                if (!this.form.photos) {
                    return photosDict
                }
                this.form.photos.forEach(photo => {
                    photosDict[photo.instagram_id] = photo
                })
                return photosDict
            }
        },
        methods: {
            synchronizePhotos () {
                // remove photos not found in instagram response
                const photoInInstaResponse = photo => this.instagramPhotos.find(insta => insta.id === photo.instagram_id)
                this.form.photos = this.form.photos.filter(photoInInstaResponse)
            },
            updatePreview () {
                if (this.previewIsUpdating) return
                this.previewIsUpdating = true
                InstagramFolder.remote({params: {tags: this.form.tags}}).then(response => {
                    this.previewIsUpdating = false
                    this.instagramPhotos = response.data
                    this.synchronizePhotos()
                }, error => {
                    this.previewIsUpdating = false
                    console.error(error)
                })
            },
            tileVisible (photo) {
                const confirmationObject = this.photosDict[photo.id]
                if (confirmationObject === undefined) {
                    return true
                }
                if (this.showAccepted && confirmationObject.accepted) {
                    return true
                }
                if (this.showUnaccepted && !confirmationObject.accepted) {
                    return true
                }
                return false
            },
            changePhotoStatus (photo, accepted) {
                if (this.photosDict[photo.id] !== undefined) {
                    this.photosDict[photo.id].accepted = accepted
                } else {
                    this.form.photos.push({
                        instagram_id: photo.id,
                        accepted: accepted,
                        link: photo.link,
                        thumbnail_image: photo.thumbnail_src,
                        standard_resolution_image: photo.thumbnail_src,
                    })
                }
            }
        },
        watch: {
            'form.tags' (value) {
                this.updatePreview()
            }
        }
    }
</script>
<style lang="scss" scoped>
    .list {
        grid-gap: 20px 20px;
        display: grid;
        padding: 0;
        grid-template-columns: repeat(4, 1fr);
    }

    .item {
        text-align: center;
        display: grid;
        max-width: 150px;
    }

    .thumbnail {
        max-width: 100%;
    }

    .photo {
        &__buttons {
            margin-top: 8px;
            display: flex;
            justify-content: space-between;
        }
    }

    .filters {
        position: relative;
        bottom: 25px;
        text-align: right;
    }
</style>


// WEBPACK FOOTER //
// PhotosPreview.vue?7e14c715